import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import {
  CommunicationTemplate,
  CommunicationTemplateViewControl,
  MessageSettings
} from 'src/app/modules/communications/store/communications';
import { TemplateDesignElement } from '../../design-element';
import { TemplateDesignerService } from 'src/app/modules/communications/services/template-designer.service';
import produce from 'immer';
import { HeaderElementSettings } from './header-control-model';
import { ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'app-header-control',
    templateUrl: './header-control.component.html',
    styleUrls: ['./header-control.component.scss'],
    standalone: false
})
export class HeaderControlComponent implements OnInit, OnDestroy, TemplateDesignElement {
  @Input() index: number;
  @Input() messageSettings?: MessageSettings;
  @Input() template?: CommunicationTemplate;
  @Input() control?: CommunicationTemplateViewControl;
  @Input() set culture(value: string) {
    this._culture = value;
    this.loadData();
  }
  @Input() orgLanguages: string[];
  @Input() selected: boolean;
  @Output() settingsChanged = new EventEmitter<{ uId: string; settings: any }>();

  _culture: string;
  editMode: boolean;
  richText: string;
  color: string = '#6e6986';

  constructor(private templateDesignerService: TemplateDesignerService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  loadSettings(): void {
    this.editMode = true;
    let settings = this.control?.settings as HeaderElementSettings;

    this.richText = this.templateDesignerService.getTranslateText(settings?.richText, this._culture);

    if (!!!settings) {
      const control = produce(this.control, draftState => {
        if (!!!draftState.settings) {
          draftState.settings = {
            richText: {},
            color: '#6e6986',
          } as HeaderElementSettings;
        }
      });

      this.control = control;

      this.settingsChanged.emit({ uId: this.control.uId, settings: control.settings });
    }
  }

  saveSettings(): boolean {
    return true;
  }

  render(): void {
    this.editMode = false;
    this.loadData();
  }

  private loadData(): void {
    this.editMode = false;

    const settings: HeaderElementSettings = this.control?.settings;

    this.color = settings?.color;
    this.richText = this.templateDesignerService.getTranslateText(settings?.richText, this._culture);
  }

  edit(): void {}
  setRuntimeData(data: any): void {}

  headerChanged(value: any): void {
    const control = produce(this.control, draftState => {
      if (!!!draftState.settings) {
        draftState.settings = {
          richText: {},
          color: '#6e6986',
        } as HeaderElementSettings;
      }
      if (!!!draftState.settings.richText) {
        draftState.settings.richText = {};
      }
      draftState.settings.richText[this._culture] = value;
    });

    this.control = control;

    this.settingsChanged.emit({ uId: this.control.uId, settings: control.settings });
  }

  colorChanged(value: any): void {
    const control = produce(this.control, draftState => {
      if (!!!draftState.settings) {
        draftState.settings = {
          richText: {},
          color: '#6e6986',
        } as HeaderElementSettings;
      }

      draftState.settings.color = value;
    });

    this.control = control;

    this.settingsChanged.emit({ uId: this.control.uId, settings: control.settings });
  }
}
